var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100vw"}},[_c('router-view',{staticStyle:{"padding":"20px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }